import { render } from "./FormDetail.vue?vue&type=template&id=aa55d6b6&scoped=true"
import script from "./FormDetail.vue?vue&type=script&lang=ts"
export * from "./FormDetail.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-aa55d6b6"

export default script
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QItem,QItemSection,QAvatar,QBtn,QFile,QIcon});
